import React from 'react'
import style from "../Content.module.css";
import {message, Tabs} from "antd";
import UserInfo from "./UserInfo";
import OperatorInfo from "./OperatorInfo";
import TeamInfo from "./TeamInfo";
import UserOrderInfo from "./UserOrderInfo";
import Axios from "../../../utils/axios";
import MajorAccount from "./MajorAccount";
import BusinessInfo from "./BusinessInfo";

const {TabPane} = Tabs;

class UserManage extends React.Component {
    state = {
        userPermission: null,
        activeKey: '1',
        visited: ['1'],
    }

    componentDidMount() {
        this.getUserPermission();
    }

    onTabChange = (key) => {
        this.setState(prev => ({
            activeKey: key,
            visited: prev.visited.includes(key) ? prev.visited : [...prev.visited, key]
        }));
    }

    getUserPermission = () => {
        Axios({
            method: 'get',
            url: '/menu/getUserMenu/' + JSON.parse(window.sessionStorage.getItem("userName")),
        }).then(res => {
            if (res.data.code === 200) {
                this.setState({
                    userPermission: res.data.data,
                });
            } else {
                message.error(res.data.message);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    render() {
        const {activeKey, visited} = this.state;
        return (
            <div className={style['content']} id='content'>
                <div className={style['content_info']}>
                    <Tabs activeKey={activeKey} onChange={this.onTabChange} defaultActiveKey="1">
                        {this.state.userPermission != null && this.state.userPermission.includes('200001') ?
                            (<TabPane tab="账户信息" key="1">
                                {visited.includes('1') ? <UserInfo userPermission={this.state.userPermission}/> : null}
                            </TabPane>) : null
                        }
                        {this.state.userPermission != null && this.state.userPermission.includes('200002') ?
                            (<TabPane tab="线上电呼" key="2">
                                {visited.includes('2') ? <OperatorInfo userPermission={this.state.userPermission}/> : null}
                            </TabPane>) : null
                        }
                        {
                            this.state.userPermission != null && this.state.userPermission.includes('200003') ?
                                (<TabPane tab="业务团队" key="3">
                                    {visited.includes('3') ? <TeamInfo userPermission={this.state.userPermission}/> : null}
                                </TabPane>) : null
                        }
                        {this.state.userPermission != null && this.state.userPermission.includes('200004') ?
                            (<TabPane tab="合作站点" key="4">
                                {visited.includes('4') ? <BusinessInfo userPermission={this.state.userPermission}/> : null}
                            </TabPane>) : null
                        }
                        {this.state.userPermission != null && this.state.userPermission.includes('200005') ?
                            (<TabPane tab="车主" key="5">
                                {visited.includes('5') ? <UserOrderInfo userPermission={this.state.userPermission}/> : null}
                            </TabPane>) : null
                        }
                        {this.state.userPermission != null && this.state.userPermission.includes('200013') ?
                            (<TabPane tab="大客户" key="6">
                                {visited.includes('6') ? <MajorAccount userPermission={this.state.userPermission}/> : null}
                            </TabPane>) : (null)
                        }
                    </Tabs>
                </div>
            </div>
        )
    }
}

export default UserManage;